import { isPresent, isSome } from '@mbfab/shared'
import dayjs from 'dayjs'
import timezone from 'dayjs/plugin/timezone'
import utc from 'dayjs/plugin/utc'
import posthog from 'posthog-js'

import { envVariables } from '../env'

dayjs.extend(utc)
dayjs.extend(timezone)

export const formatVisitTimestamp = (): string => dayjs().tz('Asia/Tokyo').format('YYYY年M月D日 H時m分s秒')

const config =
  isPresent(envVariables.POSTHOG_API_KEY) && isPresent(envVariables.POSTHOG_API_URL)
    ? { apiKey: envVariables.POSTHOG_API_KEY, apiUrl: envVariables.POSTHOG_API_URL }
    : undefined
if (isSome(config)) {
  posthog.init(config.apiKey, {
    api_host: config.apiUrl,
    // logtail 廃止に伴い、warn/error ログの送信先を PostHog Logs に統一する（logger.ts 参照）。
    // serviceName/environment は OTel の resource attribute に載り、他サービスのログと横断検索できる
    logs: { serviceName: 'mbfab-client', environment: envVariables.NODE_ENV },
  })
}

// logger.ts が「PostHog へ送信できる状態か」を判定するために参照する。
// config はこのモジュール内に閉じ、判定結果だけを公開する
export const isPosthogInitialized = isSome(config)

export const Posthog = {
  identify(identityId: string, properties: Record<string, unknown>): void {
    if (!isSome(config)) {
      return
    }
    posthog.identify(identityId, properties)
    posthog.people.set(properties)
  },
  trackAccess(pathname: string, properties: Record<string, unknown>): void {
    if (isSome(config) && properties.role !== 'admin') {
      posthog.capture('visit', { ...properties, pathname, timestampJa: formatVisitTimestamp() })
    }
  },
}
